import * as React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import Localize from 'app/src/localize/Localize';
import Modules from 'shared_modules/Modules';

/**
 * Renders an informational Alert when a preauthorization transaction is in progress
 * and the active gateway has tipping or surcharging enabled — since neither is
 * supported during preauth.  Returns null when not applicable.
 */
const PreauthDisclaimer = ({ paymentProvider, captureMethod }) => {
  const isPreAuth = Modules.hasModule('payments.pre_auth') && captureMethod === 'manual';

  if (!isPreAuth) return null;

  const tippingParam = get(
    paymentProvider,
    'activeGateway.attributes.parameters.terminalTippingEnabled',
    false
  );
  const isTippingEnabled = tippingParam === true || tippingParam === 'true';
  const isSurchargeEnabled =
    parseFloat(get(paymentProvider, 'activeGateway.attributes.parameters.surcharge', '0')) > 0;

  let featureLabel = null;
  if (isTippingEnabled && isSurchargeEnabled) {
    featureLabel = <strong>{Localize.translate('tipping or surcharging')}</strong>;
  } else if (isTippingEnabled) {
    featureLabel = <strong>{Localize.translate('tipping')}</strong>;
  } else if (isSurchargeEnabled) {
    featureLabel = <strong>{Localize.translate('surcharging')}</strong>;
  }

  if (!featureLabel) return null;

  return (
    <Alert type="info" noCloseBtn mt={2}>
      {Localize.translate("Preauthorizations don't support")} {featureLabel}.{' '}
      {Localize.translate('Only the sale total is preauthorized.')}
    </Alert>
  );
};

PreauthDisclaimer.propTypes = {
  paymentProvider: PropTypes.shape({}),
  captureMethod: PropTypes.string,
};

PreauthDisclaimer.defaultProps = {
  paymentProvider: null,
  captureMethod: null,
};

export default PreauthDisclaimer;
